import 'core-js/fn/object/assign';
import React from 'react';
import ReactDOM from 'react-dom';
import {Router, Route, hashHistory} from 'react-router'
//页面模块
import Login from './pages/login'
import Register from './pages/register'
import Lists from './pages/list'
import Service from './pages/service'
import HomePage from './pages/homePage'

import 'styles/app.css'

ReactDOM.render(
  <Router history={hashHistory}>
    <Route path="/" component={Login}/>
    <Route path="/login" component={Login}/>
    <Route path="/register" component={Register}/>
    <Route path="/list" component={Lists}/>
    <Route path="/service" component={Service}/>
    <Route path="/homePage" component={HomePage}/>
  </Router>, document.getElementById('app'));



// WEBPACK FOOTER //
// ./src/index.js